import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, Loader2Icon } from 'lucide-react';
import { easeOut } from '../../utils/motion';
interface NewsletterFormProps {
  tone?: 'light' | 'dark';
  cta?: string;
  successMessage?: string;
}
type Status = 'idle' | 'loading' | 'success' | 'error';
export function NewsletterForm({
  tone = 'light',
  cta = 'M’inscrire',
  successMessage = 'C’est noté ! Vous serez prévenu·e des prochaines arrivées.'
}: NewsletterFormProps) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const dark = tone === 'dark';
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('loading');
    window.setTimeout(() => setStatus('success'), 700);
  };
  return <div data-id="element-611" data-mp="1ufkjq2hd1mit">
      <AnimatePresence mode="wait" initial={false} data-id="element-612" data-mp="1ug3tgvwux4lr">
        {status === 'success' ? <motion.p key="ok" initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.22,
        ease: easeOut
      }} className={`flex items-center gap-2 text-sm ${dark ? 'text-paper' : 'text-ink'}`} role="status" data-id="element-613" data-mp="2kcchfd5io1b2">
            <CheckIcon className="h-4 w-4 text-sage" data-id="element-614" data-mp="2y496177z7t2p" /> {successMessage}
          </motion.p> : <motion.form key="form" onSubmit={submit} noValidate exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} data-id="element-615" data-mp="333ddntf95iqx">
            <div className={`flex items-center border-b pb-2 ${status === 'error' ? 'border-clay' : dark ? 'border-paper/40' : 'border-ink/40'}`} data-id="element-616" data-mp="3c1xpcameas5n">
              <label htmlFor={`nl-${tone}`} className="sr-only" data-id="element-617" data-mp="1ho69uuhdxe2a">
                Adresse e-mail
              </label>
              <input id={`nl-${tone}`} type="email" value={email} onChange={e => {
            setEmail(e.target.value);
            if (status === 'error') setStatus('idle');
          }} placeholder="Votre adresse e-mail" aria-invalid={status === 'error'} aria-describedby={status === 'error' ? `nl-err-${tone}` : undefined} className={`min-w-0 flex-1 bg-transparent py-2 text-sm outline-none ${dark ? 'text-paper placeholder:text-paper/50' : 'text-ink placeholder:text-muted'}`} data-id="element-618" data-mp="1mm7sjeawfbd8" />
              <button type="submit" disabled={status === 'loading'} className={`inline-flex shrink-0 items-center gap-1.5 text-sm font-medium ${dark ? 'text-paper' : 'text-ink'}`} data-id="element-619" data-mp="3houqxp0xwpj5">
                {status === 'loading' ? <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-620" data-mp="3rl67ir7kc1je" /> : cta}
                {status !== 'loading' && <ArrowRightIcon className="h-4 w-4" data-id="element-621" data-mp="3mm30j180vl8s" />}
              </button>
            </div>
            {status === 'error' && <p id={`nl-err-${tone}`} className={`mt-2 text-xs ${dark ? 'text-[#E9A88F]' : 'text-clay'}`} data-id="element-622" data-mp="f3eltwt7yfvo">
                Merci d’indiquer une adresse e-mail valide.
              </p>}
          </motion.form>}
      </AnimatePresence>
    </div>;
}